import { ChevronLeft } from 'lucide-react'

import { cn } from '@/lib/utils'
import { DropdownMenuSubContent } from '@/ui/dropdown-menu'
import { PopoverContent } from '@/ui/popover'

import type { ReactNode } from 'react'

export type DataGridFilterPresentation = 'chip' | 'content' | 'menu'

export function DataGridFilterPanel({
  presentation,
  className,
  children,
}: {
  presentation: DataGridFilterPresentation
  className?: string
  children: ReactNode
}) {
  const panelClassName = cn('gap-0 overflow-hidden p-0', className)
  if (presentation === 'menu') {
    return <DropdownMenuSubContent className={panelClassName}>{children}</DropdownMenuSubContent>
  }
  return <PopoverContent align="end" className={panelClassName}>{children}</PopoverContent>
}

export function DataGridFilterHeader({
  label,
  description,
  onBack,
}: {
  label: string
  description?: string
  onBack?: () => void
}) {
  return (
    <div className="border-border flex min-h-11 items-center border-b px-3 py-2">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back to filter columns"
          className="text-foreground hover:bg-accent focus-visible:ring-ring/30 -ml-1 inline-flex h-7 items-center gap-1 rounded-md px-1.5 text-xs font-medium outline-hidden focus-visible:ring-2"
        >
          <ChevronLeft aria-hidden className="size-3.5" />
          {label}
        </button>
      ) : (
        <div className="flex min-w-0 flex-col gap-0.5">
          <span className="text-foreground text-xs font-medium">
            Filter {label.toLocaleLowerCase()}
          </span>
          {description ? (
            <span className="text-muted-foreground text-[11px]">{description}</span>
          ) : null}
        </div>
      )}
    </div>
  )
}

export function DataGridFilterBody({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return <div className={cn('flex flex-col gap-2 p-3', className)}>{children}</div>
}
